<template lang="">
    <div>
        <div class="banner">
            <div class="swipe-wrap">
                <van-swipe :autoplay="3000" indicator-color="white" width="100%" ref="banner">
                    <van-swipe-item v-for="(banner, b) in info.banners" :key="b">
                        <van-image
                            width="100%"
                            height="100%"
                            fit="cover"
                            :src="banner.url"
                            :alt="banner.id"
                        />
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>
        <div class="title-wrap">
            <div class="left">
                <h1>{{ info.name }}</h1>
                <div class="desc">
                    <img src="@images/address-ico.png" alt="" />
                    <span>
                        地址
                        <b class="nomarl">{{ info.address }}</b>
                    </span>
                </div>
            </div>
            <div class="right" @click="showTips = true">
                <div class="img"><img src="@images/share-ico.png" alt="分享" /></div>
                <p>分享</p>
            </div>
        </div>
        <div class="content-wrap">
            <div class="block no-padding">
                <div class="title">场馆介绍</div>
                <div class="content" v-html="info.content"></div>
            </div>
        </div>
        <div class="content-wrap">
            <div class="block no-padding">
                <div class="title">场馆预约</div>
                <div class="reserve-wrap">
                    <div class="form-item">
                        <div class="label">预约时间</div>
                        <div class="date-picker" @click="showPicker = true">
                            <div class="date">
                                <div class="img"><img src="@images/date-ico.png" alt="" /></div>
                                <span v-text="field.reserve_date"></span>
                            </div>
                            <van-icon name="arrow" size="16" />
                        </div>
                    </div>
                    <div class="form-item hours-item">
                        <div class="label">预约时段</div>
                        <div class="date-picker">
                            <div class="hours">
                                <div
                                    class="hour"
                                    v-for="(hour, h) in hours"
                                    :key="h"
                                    @click="onSelectHour(hour)"
                                    :class="hoursColorClass(hour)"
                                >
                                    {{ hour.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="label">预约用途</div>
                        <div class="date-picker" @click="showSelectPicker = true">
                            <span v-text="field.use_desc || '请选择'"></span>
                            <van-icon name="arrow" size="16" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="btn-wrap">
                <van-button type="primary" block @click="submit">提交预约</van-button>
            </div>
        </div>
        <MsgPopup ref="tips"></MsgPopup>
        <div class="wechat-alipay-tips-view" v-show="showTips" @click="showTips = false"></div>
        <van-popup v-model="showPicker" position="bottom">
            <van-datetime-picker
                type="date"
                title="选择预约时间"
                @confirm="onConfirm"
                @cancel="showPicker = false"
                :min-date="minDate"
                :max-date="maxDate"
            />
        </van-popup>
        <van-popup v-model="showSelectPicker" round position="bottom">
            <van-picker
                title=""
                show-toolbar
                :columns="columns"
                @confirm="onConfirmSelect"
                @cancel="showSelectPicker = false"
            />
        </van-popup>
    </div>
</template>
<script>
import MsgPopup from '@components/MsgPopup';
import { mapGetters } from 'vuex';
import { empty, isWeixin, formatDate } from '@utils';
import { getVenueInfo, reserveVenue, venueReserve } from '@api/venue'; //, applyVenue
import { wechatEvevt } from '@libs/wechat';
import { getShare, getVenueData } from '@api/public';
import { getUserInfo } from '@api/user';
import toLogin from '@libs/login';
import cookie from '@utils/store/cookie';
export default {
    name: 'venueDetail',
    components: {
        MsgPopup
    },
    data() {
        return {
            info: {
                id: 0,
                name: '',
                banners: [],
                content: '',
                address: ''
            },
            showTips: false,
            showPicker: false,
            showSelectPicker: false,
            hours: [
                {
                    id: '09:00-10:30',
                    name: '09:00-10:30',
                    disable: false
                },
                {
                    id: '10:40-12:10',
                    name: '10:40-12:10',
                    disable: false
                },
                {
                    id: '14:00-15:30',
                    name: '14:00-15:30',
                    disable: false
                },
                {
                    id: '15:40-17:10',
                    name: '15:40-17:10',
                    disable: false
                }
            ],
            field: {
                reserve_date: '',
                use_desc: '',
                reserve_hour: ''
            },
            columns: [],
            userInfo: {}
        };
    },
    created() {
        this.$set(this.info, 'id', this.$route.params.id || 0);
        if (empty(this.info.id) || this.info.id <= 0)
            return this.$dialog.error('参数错误').then(() => {
                this.$router.back();
            });
        this.getVenueParams();
    },
    computed: {
        ...mapGetters(['isLogin']),
        minDate: function() {
            let date = new Date();
            return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
        },
        maxDate: function() {
            let date = new Date();

            return new Date(date.getFullYear(), date.getMonth() + 1, date.getDate());
        }
    },
    watch: {
        $route(n) {
            if (n.name === 'venueDetail') {
                this.getInfo();
                this.getUserData();
            }
        },
        'field.reserve_date': function() {
            this.searchVenueReserve();
        }
    },
    mounted: function() {
        this.getInfo();
        this.getUserData();
        this.field.reserve_date = formatDate(this.minDate);
    },
    methods: {
        getInfo() {
            let that = this;
            getVenueInfo(this.info.id).then(res => {
                that.$set(that, 'info', res.data);
                that.searchVenueReserve();
                if (isWeixin()) {
                    let configAppMessage = {
                        desc: res.data.name,
                        title: res.data.name,
                        link: location.href,
                        imgUrl: res.data.thumb
                    };
                    wechatEvevt(
                        ['updateAppMessageShareData', 'updateTimelineShareData'],
                        configAppMessage
                    )
                        .then(res => {
                            console.log(res);
                            console.log('微信分享设置完成');
                        })
                        .catch(res => {
                            if (res.is_ready) {
                                res.wx.updateAppMessageShareData(configAppMessage);
                                res.wx.updateTimelineShareData(configAppMessage);
                            }
                        });
                }
            });
        },
        getVenueParams() {
            let that = this;
            getVenueData().then(res => {
                that.$set(that, 'columns', res.data.appointments);
            });
        },
        setOpenShare: function() {
            if (isWeixin()) {
                getShare().then(res => {
                    var data = res.data.data;
                    var configAppMessage = {
                        desc: data.desc,
                        title: data.title,
                        link: location.href,
                        imgUrl: data.img
                    };
                    wechatEvevt(
                        ['updateAppMessageShareData', 'updateTimelineShareData'],
                        configAppMessage
                    )
                        .then(res => {
                            console.log(res);
                            console.log('微信分享设置完成');
                        })
                        .catch(res => {
                            if (res.is_ready) {
                                res.wx.updateAppMessageShareData(configAppMessage);
                                res.wx.updateTimelineShareData(configAppMessage);
                            }
                        });
                });
            }
        },
        getUserData() {
            let that = this;
            if (this.isLogin) {
                getUserInfo(this.id)
                    .then(res => {
                        that.$set(that, 'userInfo', res.data);
                    })
                    .catch(() => {
                        return that.$store.commit('LOGOUT');
                    });
            }
        },
        onConfirm(time) {
            this.field.reserve_date = formatDate(time);
            this.showPicker = false;
        },
        submit() {
            let that = this;
            if (empty(this.field.reserve_hour)) {
                return this.$dialog.error('请选择预约时段');
            }
            if (empty(this.field.use_desc)) {
                return this.$dialog.error('请选择预约用途');
            }
            if (this.isLogin) {
                this.$dialog.loading('预约中...');
                reserveVenue(this.info.id, this.field)
                    .then(res => {
                        return that.$dialog.close().then(() => {
                            that.$dialog.success(res.msg).then(() => {
                                that.$router.replace('/user/reserve');
                            });
                        });
                    })
                    .catch(err => {
                        return that.$dialog.close().then(() => {
                            that.$dialog.error(err);
                        });
                    });
            } else {
                this.$refs.tips.show(0, '提示', '请先登陆', '授权登陆', function() {
                    cookie.set('login_back_url', '/classes/' + that.info.id);
                    return toLogin();
                });
            }
        },
        onConfirmSelect(value) {
            this.$set(this.field, 'use_desc', value);
            this.$set(this, 'showSelectPicker', false);
        },
        searchVenueReserve() {
            let that = this;
            venueReserve(this.info.id, { reserve_date: this.field.reserve_date })
                .then(res => {
                    this.field.reserve_hour = '';
                    if (res.data) {
                        if (res.data.length > 0) {
                            res.data.forEach(item => {
                                that.hours.forEach(hour => {
                                    if (hour.id == item.hours) {
                                        hour.disable = true;
                                    }
                                });
                            });
                        } else {
                            that.hours.forEach(hour => {
                                if (hour.disable == true) {
                                    hour.disable = false;
                                }
                            });
                        }
                    } else {
                        that.hours.forEach(hour => {
                            if (hour.disable == true) {
                                hour.disable = false;
                            }
                        });
                    }
                })
                .catch(err => {
                    return that.$dialog.error(err);
                });
        },
        onSelectHour(hour) {
            if (hour.disable) return this.$dialog.error('当前时段已被预定');
            this.field.reserve_hour = hour.id;
        },
        hoursColorClass(hour) {
            if (hour.disable) return 'disable';
            let color = this.field.reserve_hour == hour.id ? 'active' : '';
            return color;
        }
    },
    beforeDestroy() {
        this.setOpenShare();
    }
};
</script>
